import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=48263522&scoped=true&"
import script from "./Root.vue?vue&type=script&lang=ts&"
export * from "./Root.vue?vue&type=script&lang=ts&"
import style0 from "./Root.vue?vue&type=style&index=0&id=48263522&prod&scoped=true&lang=css&"
import style1 from "./Root.vue?vue&type=style&index=1&id=48263522&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48263522",
  null
  
)

export default component.exports